<template>
  <div v-if="showUpdateMessages" class="update-message-mask">
    <div class="update-message-top">
      <Resource
        class="h-full"
        :src="
          getBeUrl(
            isGlobalVersion()
              ? '/youyan/images/default/rendora_org_logo.png'
              : '/youyan/images/default/youyan_org_logo.png'
          )
        "
        alt="logo"
      />
    </div>
    <div class="update-message-container">
      <Resource
        class="w-[270px]"
        :src="getFeUrl('/youyan-platform/png/No_Address_illustration%402x.png')"
        :transform-resource="transformImage"
        alt=""
      />
      <div class="mt-[20px] mb-[12px] text-[20px] font-semibold">
        {{ $t('ting-fu-geng-xin-zhong') }}
      </div>
      <p class="text-[12px] leading-[20px] m-0 w-[400px]">
        {{ updateMsg?.notice_text }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
const updateMsg = useUpdateMessage()
const showUpdateMessages = useShowUpdateMessage()
</script>

<style lang="scss" scoped>
.update-message-mask {
  @apply fixed top-0 left-0 w-full h-full bg-back-1 z-[10086] flex-center text-center;
  .update-message-top {
    @apply bg-back-1 absolute w-full left-0 flex items-center px-[46px];
    display: flex;
    align-items: center;
    top: 15px;
    height: 30px;
  }
}
</style>
